import React from "react";
import { useLang } from "@/lib/i18n";
import { Reveal } from "./Section";

export default function Definition() {
  const { t } = useLang();
  return (
    <section
      id="definition"
      data-testid="section-definition"
      className="relative bg-[#0F1114] text-white pt-20 md:pt-28"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-14">
        <Reveal>
          <p
            data-testid="definition-text"
            className="max-w-4xl text-white/80 font-display font-light tracking-[-0.01em] leading-[1.35] border-l-2 border-[#F5D77A]/70 pl-6 md:pl-8"
            style={{ fontSize: "clamp(1.15rem, 1.9vw, 1.85rem)" }}
          >
            {t.hero.definition}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
